var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainRelayBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 245 97",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff3c00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.22 25.55h29.43v-7.74h-29.61v-7.02h38.79v21.69h-29.52v8.46c11.7.81 26.1-.27 36.45-3.42l1.53 7.02c-11.43 3.51-30.15 4.5-47.07 2.88v-21.87zm10.44 64.53v-21.69h45.54v-7.38h-45.72v-7.11h54.9v21.33h-45.54v7.56h48.15v7.29s-57.33 0-57.33 0zm45.45-40.32v-43.47h9.27v43.47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.39 66.05c8.1.72 18.36-.09 25.83-2.7l1.53 7.38c-9 3.06-23.31 3.87-36.18 2.25v-31.41h22.32v-15.48h-22.5v-7.47h31.32v30.33h-22.32zm35.1-24.48v-33.3h8.73v78.21h-8.73v-37.17h-9.27v-7.74zm17.01-35.28h8.91v84.42h-8.91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.64 46.07c0-18.81 7.47-30.24 22.5-30.24s22.41 11.43 22.41 30.33-7.47 30.24-22.41 30.24-22.5-11.52-22.5-30.33zm35.73.09c0-14.4-4.23-22.41-13.23-22.41s-13.32 8.01-13.32 22.41 4.32 22.41 13.32 22.41 13.23-8.01 13.23-22.41zm22.41 44.55v-84.42h9.18v84.42z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m244 1v95h-243v-95zm1-1h-245v97h245z",
    fill: "#666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainRelayBorder);
export default __webpack_public_path__ + "static/media/main_relay_border.97b691728c13d431d96f1de234bb9374.svg";
export { ForwardRef as ReactComponent };